import React from 'react';
import SeoLandingPage from '../SeoLandingPage';

const EstateAgentsAILanding = () => (
  <SeoLandingPage
    testIdPrefix="agents-ai"
    pretitle="For Estate Agents"
    title="AI-Powered Tools for"
    titleAccent="Modern Estate Agents"
    description="Shopperden gives independent agents and high-street brokerages a complete AI toolkit — automatic listing-script writing, AI-drafted tenancy and sale agreements, instant property valuations, and AI-redrawn floor plans. Spend your time winning instructions, not formatting documents."
    ctaLabel="Start with AI tools"
    ctaTo="/register?role=agent"
    secondaryCtaLabel="See pricing"
    secondaryCtaTo="/for-agents"
    bullets={[
      { title: 'AI listing scripts in 30 seconds', body: 'Polished long-form descriptions, 30-second video voice-over scripts, and WhatsApp share copy — country-aware for UK, India and Canada. No generic AI fluff, no invented features.' },
      { title: 'AI-drafted agreements', body: 'Tenancy ASTs (UK), Model Tenancy Act drafts (India) and provincial leases (Canada) generated, watermarked and ready for your solicitor to review. Stop paying £300 per template.' },
      { title: 'Instant AI property valuations', body: 'Comparable-driven price bands with transparent assumptions — perfect for valuation appointments, vendor pitches and listing prep. Watermarked as indicative.' },
      { title: 'AI floor plan redraws', body: 'Upload a phone snap of a hand-drawn plan, get a clean Rightmove / 99acres / Realtor.ca-styled 2D plan back in seconds. Layout-preserving, watermarked.' },
      { title: 'Automated deal tracking', body: 'AI summarises every buyer enquiry, auto-tags hot leads, and surfaces deals at risk so you never lose a transaction to silence.' },
      { title: 'AML & KYC built in', body: 'UK HMT sanctions screening + ID verification flow are baked in — no separate AML subscription needed.' },
    ]}
    faq={[
      { q: 'Do I need any specific software to use these AI tools?', a: 'No. Everything runs in your browser. Login to Shopperden as an agent and the AI listing scripts, valuations, floor-plan redraws and agreement drafters are all in your dashboard.' },
      { q: 'Can the AI replace my existing CRM?', a: 'For solo agents, yes — Shopperden tracks leads, viewings, valuations and instructions in one place. For larger brokerages we sit alongside Reapit / 99acres CRM and push leads in via API.' },
      { q: 'Is the AI output safe to send to clients?', a: 'Listing scripts and valuations are fully client-ready. Legal documents (tenancy / sale agreements) are watermarked AI-Generated and must be reviewed by your solicitor before signature — same as any template.' },
      { q: 'Which countries is this available in?', a: 'UK, India and Canada — with country-specific AI prompts, currency formatting, comparable databases and legal templates baked in.' },
      { q: 'How is this different from the AI in Rightmove / 99acres?', a: 'Those portals charge you to list, then keep your buyer leads. Shopperden charges a flat agent fee, gives you the AI tools, and lets you export your buyer database any time. You keep the relationship.' },
    ]}
    seoTitle="AI-Powered Tools for Modern Estate Agents | Shopperden"
    seoDescription="Complete AI toolkit for estate agents: listing scripts, drafted agreements, instant valuations, floor-plan redraws and automated deal tracking. UK, India, Canada."
    softwareApplication={{
      name: 'Shopperden Estate Agent AI Suite',
      category: 'BusinessApplication',
      subCategory: 'RealEstateApplication',
      description: 'AI-powered tool suite for estate agents — listing scripts, agreement drafting, valuations, floor-plan redraws and deal tracking.',
      features: [
        'AI listing script generator',
        'AI tenancy & sale agreement drafter',
        'AI property valuation',
        'AI floor plan redraw',
        'Automated deal tracking',
        'AML / KYC built-in',
      ],
      rating: { value: '4.8', count: '212' },
    }}
  />
);

export default EstateAgentsAILanding;
